import { GrowthDashboardTopBarActions, LandingPagesView } from '@elva/ui';
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { AsyncBoundary } from '@/components/feedback';
import { usePageTopBar } from '@/app/layouts/pageTopBar';
import { viewProps } from '@/data/viewProps';
import { useLandingPages } from '../hooks/useLandingPages';

function livePageUrl(url: string): string {
  const trimmed = url.trim();
  if (!trimmed || trimmed === '—') return '';
  if (/^https?:\/\//i.test(trimmed)) return trimmed;
  return `https://${trimmed}`;
}

export function LandingPagesPage() {
  const navigate = useNavigate();

  usePageTopBar({
    actions: <GrowthDashboardTopBarActions />,
  });

  const { data, isPending, isError, error, refetch, isRefetching, isFetching } = useLandingPages();

  const handleViewLive = useCallback((_id: string, url: string) => {
    const live = livePageUrl(url);
    if (live) window.open(live, '_blank', 'noopener,noreferrer');
  }, []);

  return (
    <AsyncBoundary
      loading={isPending}
      error={data === undefined && isError ? error : undefined}
      onRetry={refetch}
      retrying={isRefetching}
    >
      <LandingPagesView
        {...viewProps({
          items: data?.items,
          stats: data?.stats,
          archivedCount: data?.archivedCount,
          loading: isFetching,
          onEdit: (pageId: string) => navigate(`/landing-pages/${pageId}`),
          onViewLive: handleViewLive,
          onReviewApprove: () => navigate('/approval-queue'),
          onNewLandingPage: () => navigate('/landing-pages/new'),
        })}
      />
    </AsyncBoundary>
  );
}
